import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { yieldCallback } from "@zillow/yield-callback";
import { IconChevronRightOutline, IconChevronLeftOutline } from "@zillow/constellation";
const ARROW_COLUMN_WIDTH = "35px";
const MediaCarouselControl = styled.span.withConfig({
  displayName: "CarouselNavigation__MediaCarouselControl",
  componentId: "sc-112echu-0"
})(["position:absolute;display:flex;align-items:center;justify-content:center;top:0;bottom:0;width:", ";&:hover{cursor:pointer;}z-index:5;"], ARROW_COLUMN_WIDTH);
const CarouselNavigation = ({
  onLeftButtonClick,
  onRightButtonClick
}) => /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
  /* @__PURE__ */ jsx(MediaCarouselControl, { style: {
    right: 0
  }, onClick: yieldCallback(() => onRightButtonClick()), children: /* @__PURE__ */ jsx(IconChevronRightOutline, {}) }),
  /* @__PURE__ */ jsx(MediaCarouselControl, { style: {
    left: 0
  }, onClick: yieldCallback(() => onLeftButtonClick()), children: /* @__PURE__ */ jsx(IconChevronLeftOutline, {}) })
] });
CarouselNavigation.propTypes = {
  onLeftButtonClick: PropTypes.func.isRequired,
  onRightButtonClick: PropTypes.func.isRequired
};
CarouselNavigation.defaultProps = {};
export {
  ARROW_COLUMN_WIDTH,
  CarouselNavigation as default
};
